import { IAction } from "../model/IAction";
import { State } from "../model/State";

import download from "downloadjs";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";


export function exportXml(): ThunkResult<void, State> {
    return async (dispatch, getState) => {
        const state = getState() as State;
        const xml = await BpmnJsCliWrapper.exportXML();
        if (!xml.error) {
            download(new Blob([xml.result as string], { type: "image/svg+xml" }), state.process.name ? state.process.name + ".bpmn" : "process.bpmn", "application/bpmn20-xml");
        } else {
            Utilities.toastError("Export failed: " + xml.error);
        }
    };
}

export function exportSvg(): ThunkResult<void, State> {
    return async (dispatch, getState) => {
        const state = getState() as State;
        const svg = await BpmnJsCliWrapper.exportSVG();
        if (!svg.error) {
            download(new Blob([svg.result as string], { type: "image/svg+xml" }), state.process.name ? state.process.name + ".svg" : "process.svg", "image/svg+xml");
        } else {
            Utilities.toastError("Export failed: " + svg.error);
        }
    };

}

export const CLEAR_ELEMENT_STATE = "CLEAR_ELEMENT_STATE";

export function clearElementState(): IAction {
    return { type: CLEAR_ELEMENT_STATE };
}
